import { PremiumCarouselM } from "./_components/premium-carousel-mobile";
import { PremiumCarouselD } from "./_components/premium-carousel-desktop";
export const PremiumCarousel = (props) => {
    return window.innerWidth <= 700 ? (React.createElement(PremiumCarouselM, Object.assign({}, props))) : (React.createElement(PremiumCarouselD, Object.assign({}, props)));
};

